import React from "react";
import { services } from "../mock";
import { Check, ArrowRight, ShieldCheck } from "lucide-react";

export default function Services() {
  const { eyebrow, title, plans, option } = services;
  return (
    <section id="tarifs" className="bg-[#F4F0E9] py-20 lg:py-24">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
        <p className="mb-3 flex items-center gap-3 text-[12px] font-semibold uppercase tracking-[0.2em] text-[#B08D57]">
          <span className="h-px w-8 bg-[#B08D57]" /> {eyebrow}
        </p>
        <h2 className="max-w-2xl font-serifDisplay text-[34px] leading-tight text-[#26241F] lg:text-[46px]">
          {title}
        </h2>

        <div id="services" className="mt-12 grid gap-6 lg:grid-cols-2">
          {plans.map((p) => (
            <div
              key={p.tag}
              className={`relative flex flex-col rounded-3xl border p-8 transition-all duration-300 lg:p-10 ${
                p.highlight
                  ? "border-[#B08D57] bg-[#26241F] text-white shadow-[0_28px_60px_-30px_rgba(38,36,31,0.6)]"
                  : "border-[#e0d8c8] bg-[#FBF9F5] text-[#26241F]"
              }`}
            >
              {p.highlight && (
                <span className="absolute right-8 top-8 rounded-full bg-[#B08D57] px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-[#26241F]">
                  La plus complète
                </span>
              )}
              <span className={`text-[12px] font-semibold uppercase tracking-[0.2em] ${p.highlight ? "text-[#B08D57]" : "text-[#B08D57]"}`}>
                {p.tag}
              </span>
              <h3 className="mt-3 text-[24px] font-semibold">{p.name}</h3>
              <p className={`mt-2 text-[15px] leading-relaxed ${p.highlight ? "text-white/70" : "text-[#6e6a62]"}`}>
                {p.description}
              </p>

              <div className="mt-6 flex items-baseline gap-2">
                <span className="font-serifDisplay text-[46px] leading-none">{p.price}</span>
                <span className={`text-[13px] ${p.highlight ? "text-white/60" : "text-[#9a9488]"}`}>{p.priceNote}</span>
              </div>

              <ul className="mt-7 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-[15px]">
                    <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${p.highlight ? "bg-[#B08D57] text-[#26241F]" : "bg-[#26241F] text-white"}`}>
                      <Check className="h-3 w-3" />
                    </span>
                    <span className={p.highlight ? "text-white/90" : "text-[#403d35]"}>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                className={`group mt-8 inline-flex items-center justify-center gap-2 rounded-md px-6 py-3.5 text-[15px] font-semibold transition-all ${
                  p.highlight
                    ? "bg-[#B08D57] text-[#26241F] hover:bg-[#c19d63]"
                    : "bg-[#26241F] text-white hover:bg-[#B08D57]"
                }`}
              >
                {p.cta}
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-4 rounded-2xl border border-[#e0d8c8] bg-[#FBF9F5] p-6 sm:flex-row sm:items-center">
          <div className="flex items-center gap-4">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#26241F] text-[#B08D57]">
              <ShieldCheck className="h-6 w-6" />
            </span>
            <div>
              <div className="text-[16px] font-semibold text-[#26241F]">{option.label}</div>
              <div className="text-[14px] text-[#6e6a62]">{option.note}</div>
            </div>
          </div>
          <div className="font-serifDisplay text-[32px] text-[#26241F]">{option.price}</div>
        </div>

        <p className="mt-5 text-center text-[13px] text-[#9a9488]">
          Tarifs indicatifs présentés TTC. Un devis détaillé vous est remis avant tout engagement.
        </p>
      </div>
    </section>
  );
}
